<template>
  <InternalLayout>
    <header class="assessment-header">
      <StepIndicator :steps="steps.length" :currentStep="currentStep" @stepClick="onStepClick" />
      <SmallHeader tag="h1">Find a hospital</SmallHeader>
    </header>
    <component :is="currentStepComponent" @submit="onSubmit" />
  </InternalLayout>
</template>

<script>
import InternalLayout from '@/components/internal-layout';
import LocationStep from '@/components/PatientAssessment/location-step';
import SmallHeader from '@/components/small-header';
import StepIndicator from '@/components/step-indicator';
import get from 'lodash/get';
import { StoreGetters } from '@/store';
import { RouterAliases } from '@/router';
import { mapGetters } from 'vuex';

const UserInfoStep = () =>
  import('@/components/PatientAssessment/user-info-step');
const SymptomsStep = () =>
  import('@/components/PatientAssessment/symptoms-step');
const CareNeedsStep = () =>
  import('@/components/PatientAssessment/care-needs-step');

export default {
  components: { InternalLayout, SmallHeader, StepIndicator },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters({
      location: StoreGetters.GET_LOCATION,
      address: StoreGetters.GET_CITY,
      resources: StoreGetters.GET_CARE_NEEDS,
      condition: StoreGetters.GET_STATE,
      gender: StoreGetters.GET_GENDER,
      age: StoreGetters.GET_AGE,
    }),
    currentStepComponent() {
      return this.steps[this.currentStep - 1];
    },
    steps() {
      return [LocationStep, UserInfoStep, SymptomsStep, CareNeedsStep];
    },
  },
  methods: {
    onStepClick(step) {
      this.$router.push({
        name: RouterAliases.PATIENT_ASSESSMENT,
        params: { step },
      });
    },
    onSubmit() {
      const newRoute =
        this.currentStep >= this.steps.length
          ? {
              name: RouterAliases.PATIENT_ASSESSMENT_RESULTS,
              query: {
                address: this.address || null,
                age: this.age,
                condition: this.condition || null,
                gender: this.gender,
                lat: get(this.location, 'lat', null),
                lng: get(this.location, 'lng', null),
                resources: this.resources.length
                  ? this.resources.join(',')
                  : null,
              },
            }
          : {
              name: RouterAliases.PATIENT_ASSESSMENT,
              params: { step: this.currentStep + 1 },
            };
      this.$router.push(newRoute);
    },
  },
};
</script>

<style lang="scss" scoped>
.assessment-header {
  margin-bottom: 24px;
  text-align: center;
}

.step-indicator {
  margin: 8px auto 6px;
}
</style>
